<template>
  <ul class="rt-site clearfix rt-site2" :style="rtSite2">
    <li v-if="showRightAd">
      <a v-if="topAdInfo.type === 'ad_2345'" v-bind:href="topAdInfo.link" target="_blank" @click="topAdClick(topAdInfo)" :id="topAdInfo.divId">
        <img :src="topAdInfo.imgUrl" :alt="topAdInfo.title" />
      </a>
      <div v-if="topAdInfo.type === 'ad_bd'" v-bind:id="topAdInfo.divId" :style="{display: topAdInfo.show}"></div>
    </li>
  </ul>
</template>
<script>
import ad from '../../api/ad';
import stats from '../../api/statistics';
import util from "../../api/util";

export default {
  name: 'AdsChuChuang',
  data () {
    return {
      topAdInfo: {},
      showRightAd: false,
      rtSite2: 'display: none !important',
      iframeRect: {
        stop: 0,
        wheight: 0
      },
      adLoadState: 'unload'
    };
  },
  props: ['pageType'],
  mounted () {
    this.$bus.$on('load_right_top_ad', (data) => {
      this.loadAdInfo(data);
    });
    this.$bus.$on('showReport', (data) => {
      this.iframeRect = data.rect;
      this.showReport();
    });
  },
  methods: {
    loadAdInfo (data) {
      if (this.adLoadState === 'loading' || this.adLoadState === 'done') {
        return ;
      }
      this.adLoadState = 'loading';
      if (data.type === 'ad_bd') {
        this.topAdInfo = {
          type: data.type,
          show: true,
          divId: data.link + '_rt_site_' + (Math.random() + '').replace('.' , ''),
          showReport: data.showReport,
          clickReport: data.clickReport
        };
        this.showRightAd = true;
        this.$nextTick(() => {
          let dependJs = 'https://newsie.2345.cc/newtab/common/e2_bdm.js';
          let renderBdwm = () => {
            if (document.querySelector('#' + this.topAdInfo.divId)) {
              util.loadJs(dependJs, () => {
                ad.getAdsList('bdwm', {
                  uid: data.link,
                  divId: this.topAdInfo.divId
                });
                this.rtSite2 = 'display: block !important';
                this.adLoadState = 'done';
                this.$bus.$emit('sendMessage', {
                  action: 'load_right_top_ad_done'
                });
                this.showReport();
              });
            } else {
              setTimeout(() => {
                renderBdwm();
              }, 300);
            }
          }
          renderBdwm();
        });
      } else if (data.type === 'ad_2345') {
        this.topAdInfo = {
          type: data.type,
          title: '2345广告',
          imgUrl: data.imgUrl,
          link: data.link,
          showReport: data.showReport,
          clickReport: data.clickReport,
          divId: 'ad_2345_rt_site_' + (Math.random() + '').replace('.' , '')
        };
        this.showRightAd = true;
        this.rtSite2 = 'display: block !important';
        this.$nextTick(() => {
          this.adLoadState = 'done';
          this.showReport();
          this.$bus.$emit('sendMessage', {
            action: 'load_right_top_ad_done'
          });
        });
      }
    },
    showReport () {
      if (this.topAdInfo['showReport']) {
        let ajaxKey = this.topAdInfo['showReport'];
        if (ajaxKey.indexOf('NewTab') < 0 && ajaxKey.indexOf('Error') < 0) {
          let prefix = this.pageType === 'newtab' ? 'NewTab' : 'Error';
          ajaxKey = prefix + '_' + ajaxKey;
        }
        stats.ajax99(ajaxKey);
        delete (this.topAdInfo['showReport']);
      }
    },
    topAdClick () {
      if (this.topAdInfo['clickReport']) {
        let ajaxKey = this.topAdInfo['clickReport'];
        if (ajaxKey.indexOf('NewTab') < 0 && ajaxKey.indexOf('Error') < 0) {
          let prefix = this.pageType === 'newtab' ? 'NewTab' : 'Error';
          ajaxKey = prefix + '_' + ajaxKey;
        }
        stats.ajax99(ajaxKey);
      }
    }
  }
}
</script>
